import React from 'react'

const Treatment = () => {
    return (
        <>
            <section className="container py-5">
                <div className="row text-center mb-4">
                    <h2 className="fw-bold">Our Specialties</h2>
                    <p className="text-muted">Comprehensive care tailored to your needs</p>
                </div>
                <div className="row g-4">
                    <div className="col-md-6 col-lg-4">
                        <div className="card h-100 shadow-sm">
                            <div className="card-body">
                                <h5 className="card-title">Chronic Disease Management</h5>
                                <p className="card-text">
                                    We  are specialize in the management of chronic conditions such as allergies, arthritis, and more, with a focus on enhancing your overall quality of life.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-lg-4">
                        <div className="card h-100 shadow-sm">
                            <div className="card-body">
                                <h5 className="card-title">Pediatric Homoeopathy</h5>
                                <p className="card-text">
                                    Our gentle and effective treatments for children address common childhood issues like allergies, ADHD, and recurring infections.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-lg-4">
                        <div className="card h-100 shadow-sm">
                            <div className="card-body">
                                <h5 className="card-title">Women's Health</h5>
                                <p className="card-text">
                                    We support women through every stage of life, from addressing menstrual problems to managing menopause, ensuring hormonal balance and well-being.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-lg-4">
                        <div className="card h-100 shadow-sm">
                            <div className="card-body">
                                <h5 className="card-title">Skin Disorders</h5>
                                <p className="card-text">
                                    Our treatments effectively address skin conditions such as eczema, psoriasis, and acne, restoring your skin’s health and radiance.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-lg-4">
                        <div className="card h-100 shadow-sm">
                            <div className="card-body">
                                <h5 className="card-title">Weight Management</h5>
                                <p className="card-text">
                                    Homoeopathy offers natural solutions for managing stress, anxiety, and mood disorders, promoting mental and emotional wellness.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="bg-light p-4 rounded shadow-sm">
                            <h2 className="fw-bold mb-3 text-center">होम्योपैथी क्या है ?</h2>
                            <p className="text-justify">
                                होम्योपैथी एक प्राकृतिक चिकित्सा पद्धति है जिसमें <strong>“समान का समान से”</strong> चिकित्सा नियम द्वारा इलाज किया जाता है।
                                होम्योपैथी का आविष्कार <strong>1796</strong> में हुआ था, जिसके जनक <strong>डॉ. क्रिश्चियन फ्रेडरिक सैम्युअल हैनिमन</strong>
                                (10 अप्रैल 1755 – 2 जुलाई 1843) थे।
                            </p>
                            <p>उन्होंने होम्योपैथी के 7 मुख्य नियम और तरीके बताए:</p>
                            <ul className="list-group list-group-flush mb-3">
                                <li className="list-group-item">1. समरूपता या सादृश्य नियम (Law of Similar)</li>
                                <li className="list-group-item">2. एकमेव औषधि (Single Medicine)</li>
                                <li className="list-group-item">3. औषधि की न्यून मात्रा (The Minimum Dose)</li>
                                <li className="list-group-item">4. व्यक्तिपरक और संपूर्ण चिकित्सा (Individualization & Totality of Symptoms)</li>
                                <li className="list-group-item">5. जीवनी शक्ति (Vital Force)</li>
                                <li className="list-group-item">6. मियाज्म (रोग बीज) (Miasm)</li>
                                <li className="list-group-item">7. औषधि प्रमाणन (Drug Proving)</li>
                            </ul>
                            <p>
                                आज लगभग सभी लोग होम्योपैथिक पद्धति के बारे में कुछ न कुछ जानते हैं, लेकिन समझने की कोशिश नहीं करते हैं।
                                इसका कारण समय का अभाव हो सकता है। लेकिन <strong>आपका शरीर आपका अपना है</strong> — उसके बारे में थोड़ी जानकारी होनी चाहिए,
                                ताकि आप खुद को सुरक्षित और स्वस्थ रख सकें।
                            </p>
                        </div>
                    </div>
                </div>
            </section>


        </>

    )
}

export default Treatment